<template>
  <div>
    <!-- Article Cache -->
    <b-collapse class="card" :open.sync="open.article">
      <div slot="trigger" slot-scope="props" class="card-header">
        <p class="card-header-title">Article</p>
        <a class="card-header-icon">
          <b-icon :icon="open.article ? 'caret-down' : 'caret-up'"></b-icon>
        </a>
      </div>
      <div class="card-content">
        <div class="content">
          <p>Clear the cache of an article</p>
        </div>
        <form @submit.prevent="submitArticleForm">
          <div class="field">
            <label class="label">URL</label>
            <div class="control">
              <input
                type="url"
                name="url"
                class="input"
                required
                placeholder="https://www.supersport.com/rugby/news/181111_Canada_power_past_Kenya_in_Rugby_World_Cup_repechage"
              >
            </div>
          </div>
          <div class="field">
            <input type="submit" value="Clear" class="button is-primary">
          </div>
        </form>
      </div>
    </b-collapse>

    <!-- Homepage -->
    <b-collapse class="card" :open.sync="open.homePage">
      <div slot="trigger" slot-scope="props" class="card-header">
        <p class="card-header-title">Home Page</p>
        <a class="card-header-icon">
          <b-icon :icon="open.homePage ? 'caret-down' : 'caret-up'"></b-icon>
        </a>
      </div>
      <div class="card-content">
        <div class="content">
          <p>Clear the cache for items on the home page of SuperSport</p>
          <form @submit.prevent="submitForm">
            <input type="hidden" name="tags[]" value="homepage">
            <div class="field">
              <label class="label">Tag</label>
              <div class="control">
                <select name="tags[]" class="input">
                  <option :key="tag" v-for="tag in tags" :value="tag">{{tag}}</option>
                </select>
              </div>
            </div>
            <div class="field">
              <input type="submit" value="Clear" class="button is-primary">
            </div>
          </form>
        </div>
      </div>
    </b-collapse>

    <!-- Sport Home -->
    <b-collapse class="card" :open.sync="open.sportHomePage">
      <div slot="trigger" slot-scope="props" class="card-header">
        <p class="card-header-title">Sport Home Page</p>
        <a class="card-header-icon">
          <b-icon :icon="open.sportHomePage ? 'caret-down' : 'caret-up'"></b-icon>
        </a>
      </div>
      <div class="card-content">
        <div class="card-content">
          <div class="content">
            <p>Clear the cache for a sport on SuperSport</p>
            <form @submit.prevent="submitForm">
              <input type="hidden" name="tags[]" value="home">
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">Tag</label>
                    <div class="control">
                      <select name="tags[]" class="input">
                        <option :key="tag" v-for="tag in tags" :value="tag">{{tag}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">Sport</label>
                    <div class="control">
                      <select name="tags[]" class="input">
                        <option :key="sport" v-for="sport in sports" :value="sport">{{sport}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field">
                <input type="submit" value="Clear" class="button is-primary">
              </div>
            </form>
          </div>
        </div>
      </div>
    </b-collapse>

    <!-- Tournament Home -->
    <b-collapse class="card" :open.sync="open.tournamentHomePage">
      <div slot="trigger" slot-scope="props" class="card-header">
        <p class="card-header-title">Tournament Home Page</p>
        <a class="card-header-icon">
          <b-icon :icon="open.tournamentHomePage ? 'caret-down' : 'caret-up'"></b-icon>
        </a>
      </div>
      <div class="card-content">
        <div class="content">
          <p>Clear the cache for a tournament on SuperSport</p>
          <form @submit.prevent="submitForm">
            <input type="hidden" name="tags[]" value="home">
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">Tag</label>
                  <div class="control">
                    <select name="tags[]" class="input">
                      <option
                        :key="tag"
                        v-if="tag !== 'featured'"
                        v-for="tag in tags"
                        :value="tag"
                      >{{tag}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">Sport</label>
                  <div class="control">
                    <select name="tags[]" class="input">
                      <option :key="sport" v-for="sport in sports" :value="sport">{{sport}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">Tournament Slug</label>
                  <div class="control">
                    <input
                      type="text"
                      name="tags[]"
                      class="input"
                      placeholder="absa-premiership"
                      required
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="field">
              <input type="submit" value="Clear" class="button is-primary">
            </div>
          </form>
        </div>
      </div>
    </b-collapse>

     <!-- Navigation -->
    <b-collapse class="card" :open.sync="open.navigation">
      <div slot="trigger" slot-scope="props" class="card-header">
        <p class="card-header-title">Navigation</p>
        <a class="card-header-icon">
          <b-icon :icon="open.navigation ? 'caret-down' : 'caret-up'"></b-icon>
        </a>
      </div>
      <div class="card-content">
        <div class="content">
          <p>Clear the cache for SuperSport's website navigation</p>
          <form @submit.prevent="submitForm">
            <input type="hidden" name="tags[]" value="menus">
            <div class="field">
              <input type="submit" value="Clear" class="button is-primary">
            </div>
          </form>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { CACHE_CLEAR_ARTICLE, CACHE_CLEAR_TAGS } from "@/store/actions";

export default {
  name: "Cache",
  data() {
    return {
      loading: false,
      open: {
        article: false,
        homePage: false,
        sportHomePage: false,
        tournamentHomePage: false,
        navigation: false
      },
      sports: [
        "football",
        "rugby",
        "cricket",
        "golf",
        "motorsport",
        "tennis",
        "athletics",
        "cycling",
        "boxing",
        "aquatics",
        "ufc",
        "wwe"
      ],
      tags: ["videos", "news", "featured"]
    };
  },
  methods: {
    submitForm(ev) {
      this.loading = true;
      let data = new FormData(ev.target);
      this.$store
        .dispatch(CACHE_CLEAR_TAGS, data)
        .then(res => {
          if (res && res.status === 204) {
            this.$success("Cache cleared successfully");
          }
        })
        .finally(() => (this.loading = false));
    },
    submitArticleForm(ev) {
      this.loading = true;
      let data = new FormData(ev.target);
      this.$store
        .dispatch(CACHE_CLEAR_ARTICLE, data)
        .then(res => {
          if (res && res.status === 204) {
            this.$success("Cache cleared successfully");
          }
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>